import { render, staticRenderFns } from "./draggable.vue?vue&type=template&id=397aff35&"
import script from "./draggable.vue?vue&type=script&lang=js&"
export * from "./draggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports